import { UserTraitsResponse } from '@myme/api';
import { provideStringValueIfNullable } from '@myme/utils';
import { AuthUser, EditAuthUser, UserData, UserRole } from './types';

const getUserRole = (user: UserData): UserRole => {
  if (user.role === 'ADMIN') {
    return 'ADMIN';
  }

  if (user.premium) {
    return 'USER-PREMIUM';
  }

  return 'USER-PREMIUM'; // TODO: change to USER after backend provides premium functionality
};

export const mapKratosResponseToAuthUser = (user: UserTraitsResponse): EditAuthUser => ({
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  fullName: `${user.firstName} ${user.lastName}`,
  displayName: user.displayName,
  profilePhoto: provideStringValueIfNullable(user.profilePhoto),
  bannerPhoto: provideStringValueIfNullable(user.bannerPhoto),
  dataPrivacy: provideStringValueIfNullable(user.dataPrivacy),
  imprint: provideStringValueIfNullable(user.imprint),
  businessTerms: provideStringValueIfNullable(user.businessTerms)
});

export const mapToAuthUser = (user: UserData): AuthUser => ({
  ...mapKratosResponseToAuthUser(user),
  role: getUserRole(user)
});
